export default {
  modelName: "area",
  label: "地區",
  fields: {
    id: {
      type: "text",
      label: 'ID',
      readonly: true
    },
    sequence: {
      type: "text",
      label: "排序",
      maxlength: 10
    },
    locales: {
      type: "locales",
      // label: "多語言內容",
      fields: {
        name: {
          type: "text",
          label: "名稱",
          autofocus: true,
          rules: "required",
          maxlength: 30
        }
      }
    },
    name: {
      type: 'text',
      label: '名稱',
      readonly: true
    },
    updated_at: {
      type: "datetime",
      label: "最後更新時間",
      readonly: true
    },
    updated_admin: {
      type: "belongsTo",
      label: "最後更新人",
      readonly: true,
      textKey: "name",
      modeldataName: "admin"
    },
    // updated_info: {
    //   type: "custom",
    //   label: "上次修改時間",
    //   getValue: (item) => {
    //     let _value = item.updated_at;
    //     if (item.updated_admin) {
    //       _value += `  ${item.updated_admin}`;
    //     }
    //     return _value;
    //   },
    // },
  },
}